import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import Zoom from 'react-medium-image-zoom';
import {
  Card,
  Box,
  Typography,
  Container,
} from '@mui/material';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'react-medium-image-zoom/dist/styles.css';
import './CarruselProducts.css';

const products = [
  // { codigo: 'P015', descripcion: 'Pizarra Acrílica Blanca Grande', precio: 50.00, imagen: 'img_15.jpg' },
  { codigo: 'P029', descripcion: 'Pizarra de Corcho', precio: 25.00, imagen: 'img_29.jpg' },
  { codigo: 'P001', descripcion: 'Ventilador Blanco', precio: 50.00, imagen: 'img_1.jpg' },
  { codigo: 'P040', descripcion: 'Mueble de Madera 1 x 1.21 m', precio: 150.00, imagen: 'img_40.jpg' },
  // { codigo: 'P003', descripcion: 'Mueble de Madera de 1.68 m x 0.73m', precio: 150.00, imagen: 'img_3.jpg' },
  // { codigo: 'P002', descripcion: 'Mueble de Madera de 1.67m x 0.76m', precio: 150.00, imagen: 'img_2.jpg' },
  { codigo: 'P006', descripcion: 'Mueble de Madera para archivar', precio: 120.00, imagen: 'img_6.jpg' },
  { codigo: 'P019', descripcion: 'Mueble de melamine de archivos de 1.3m x 0.85m', precio: 180.00, imagen: 'img_19.jpg' },
  { codigo: 'P058', descripcion: 'Mueble de madera con vidrio', precio: 150.00, imagen: 'img_58.jpg' },
  { codigo: 'P010', descripcion: 'Mueble melamine blanco', precio: 50.00, imagen: 'img_10.jpg' },
  { codigo: 'P053', descripcion: 'Mueble melamine blanco', precio: 50.00, imagen: 'img_53.jpg' },
  { codigo: 'P020', descripcion: 'Silla de vidrio', precio: 60.00, imagen: 'img_20.jpg' },
  { codigo: 'P034', descripcion: 'Silla de plástico blanca', precio: 10.00, imagen: 'img_34.jpg' },
  { codigo: 'P048', descripcion: 'Silla de escritorio negra', precio: 25.00, imagen: 'img_48.jpg' },
  { codigo: 'P018', descripcion: 'Silla de espera negra', precio: 25.00, imagen: 'img_18.jpg' },
  { codigo: 'P021', descripcion: 'Mesa de Directorio Marrón oscuro de 1.72x0.59m', precio: 300.00, imagen: 'img_21.jpg' },
  { codigo: 'P041', descripcion: 'Mesa de Recepción de madera', precio: 600.00, imagen: 'img_41.jpg' },
  // { codigo: 'P013', descripcion: 'Mesa de escritorio marron de 2.16m x 0.61m', precio: 150.00, imagen: 'img_13.jpg' },
  { codigo: 'P061', descripcion: 'Mesa de escritorio de melamina en "L"', precio: 180.00, imagen: 'img_61.jpg' },
  { codigo: 'P060', descripcion: 'Mesa de centro negra con vidrio', precio: 60.00, imagen: 'img_60.jpg' },
  { codigo: 'P043', descripcion: 'Ventilador Celeste', precio: 20.00, imagen: 'img_43.jpg' },
  { codigo: 'P044', descripcion: 'Ventilador Plomo', precio: 20.00, imagen: 'img_44.jpg' },
  { codigo: 'P052', descripcion: 'Refrigeradora Ploma', precio: 350.00, imagen: 'img_52.jpg' },
  { codigo: 'P062', descripcion: 'Aire Acondicionado Marca Carrier', precio: 1200.00, imagen: 'img_62.jpg' },
  // { codigo: 'P045', descripcion: 'Locker', precio: null, imagen: 'img_45.jpg' }
];

export default function CarruselProductos() {
  return (
    <Container sx={{ maxWidth: '1200px', mx: 'auto', px: 2, py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="primary">
          Venta de Garage Lavoro
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Dirección: Pasaje Tello 201 Miraflores
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Días de la venta: viernes 23 y sábado 24 de mayo, 2025
        </Typography>
      </Box>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        // pagination={{ clickable: false }}
        spaceBetween={16}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {products.map((product, index) => (
          <SwiperSlide key={index}>
            <Card className="product-card" elevation={3}>
              <Box className="image-wrapper">
                <Zoom>
                  <img
                    src={`/images/${product.imagen}`}
                    alt={product.descripcion}
                    className="product-image"
                  />
                </Zoom>
                <Box className="overlay-text">
                  {/* <Typography variant="h6" fontWeight="bold" color="white">
                    {product.codigo}
                  </Typography> */}
                  <Typography variant="h6" fontWeight="bold" color="white">
                    {product.descripcion}
                  </Typography>
                  {product.precio !== null && (
                    <Typography variant="body1" color="#52c41a" fontWeight="bold">
                      S/.{product.precio.toFixed(2)}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
}
